<template>
  <div class="tab side-nav">
    <div :class="[isOn(item) ? 'side-nav-box js-side-nav on' : 'side-nav-box js-side-nav ']"
      v-for="item in config.daoHangList" :key="item.id">
      <h2 class="icon01" @click="changeOneMenu(item)">
        <a>{{item.title}}</a>
      </h2>
      <ul v-if="item.child.length > 1">
        <li v-for="ii in item.child" :key="ii.id" :class="[ii.id === tabId ? 'this' : '']" @click="changeTwoMenu(ii)">
          <a>{{ii.title}}</a>
        </li>
      </ul>
    </div>
    <div class="side-nav-box code" v-if="hasApp">
      <a>
        <div class="code-box">
          <img src="/search/app/markappqrcode">
          <p>手机扫一扫<br>把信息装进口袋</p>
        </div>
      </a>
    </div>
    <div class="side-nav-box other" v-if="otherBkzn.length > 0">
      <h3>其他考试报考指南</h3>
      <div class="other-test">
        <a :href="'#/?id=' + item.id" target="_blank" v-for="item in otherBkzn" :key="item.id">{{item.title}}</a>
      </div>
    </div>
  </div>
</template>

<script>
import { HasApp, GetOtherBkzn } from "../../../lib/request"
export default {
  name: "Tab",
  props: {
    tabId: {
      type: Number,
      default: 0
    },
    config: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      hasApp: false,
      otherBkzn: []
    }
  },
  mounted() {
    this.HasApp()
    this.GetOtherBkzn(this.tabId)
  },
  methods: {
    isOn(item) {
      return !!item.child.find(v => this.tabId === v.id) || item.id === this.tabId
    },
    changeOneMenu(item) {
      this.$emit("updateTabId", item.child.length === 1 ? item.child[0].id : item.id, item.child.length === 1, item.child.length === 1 && item.child[0].title === "辅导课程", item.child.length === 1 && item.child[0].title === "辅导老师")
    },
    changeTwoMenu(item) {
      this.$emit('updateTabId', item.id, true, item.title === "辅导课程", item.title === "辅导老师")
    },
    HasApp() {
      HasApp({}, (res) => {
        this.hasApp = res.Result
      })
    },
    GetOtherBkzn(id) {
      GetOtherBkzn({ id }, (res) => {
        this.otherBkzn = res.Result || []
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.tab{
  width: 210px;
  background: #fff;
  box-shadow: 0px 2px 30px 0px rgba(90, 104, 130, 0.08);
}
</style>